import React from "react";
import Header from "./Header";

const Education = () => {
    return(
        <>
        <Header></Header>
        <section className="education" id="education">
        <h2 className="heading">Education</h2>
        <div className="timeline-items">
            <div className="timeline-item">
                <div className="timeline-dot"></div>
                <div className="timeline-date">2024</div>
                <div className="timeline-content">
                    <h3>University</h3>
                    <p>Mohamed Sathak A.J College of Engineering<br />(2020-2024)</p>
                </div>
            </div>
            <div className="timeline-item">
                <div className="timeline-dot"></div>
                <div className="timeline-date">2020</div>
                <div className="timeline-content">
                    <h3>High School</h3>
                    <p>RAJ Matriculation Higher Secondary School<br />(2019-2020)</p>
                </div>
            </div>
        </div>
    </section>
    </>
    )
}
export default Education;